import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { User } from '../services/authService';

export interface SidebarStateProps {
  user: User | null;
  sidebarOpen: boolean;
  onToggleSidebar: () => void;
  onSignOut: () => Promise<void>;
  onShowAuthModal: () => void;
  authLoading: boolean;
}

export const useSidebarState = () => {
  const { user, loading: authLoading, logout } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  const sidebarProps: SidebarStateProps = {
    user,
    sidebarOpen,
    onToggleSidebar: toggleSidebar,
    onSignOut: logout,
    onShowAuthModal: () => {}, // No longer needed with ProtectedRoute
    authLoading,
  };

  return { 
    sidebarProps, 
    toggleSidebar,
    user,
    authLoading 
  };
};

